const deliveryConditions = {
  orderConfirmation: 'Innerhalb von {time} Minuten nach Bestellbestätigung',
  deliveryByAppointment: 'Botendienst mit Termin',
  deliveryByAgreement: 'Botendienst nach Vereinbarung',
  expressDelivery: 'Express-Botendienstlieferung',
  deliveryCost: 'Botendienstkosten: {cost}',
  nextDelivery: 'Nächstmöglicher Lieferzeitpunkt',
  pickupTip: 'Ihre Bestellung ist in der Regel noch am selben Tag abholbereit*',

  deliveryThreshold: 'Lieferung ab: {cost}',
  freeDeliveryThreshold: 'Kostenfreie Lieferung ab: {cost}',

  expressDeliveryThreshold: 'Express-Lieferung ab: {cost}',
  freeExpressDeliveryThreshold: 'Kostenfreie Express-Lieferung ab: {cost}',

  zipCodes: 'Lieferung an PLZ: {codes}',
  distanceLimit: 'Lieferung im Radius von: {distance}',
}

export default deliveryConditions
